import Select from "react-select";
import CreatableSelect from "react-select/creatable";

function applySelectPortalDefaults(Component) {
  Component.defaultProps = {
    ...(Component.defaultProps || {}),
    menuPosition: "fixed",
  };
  Object.defineProperty(Component.defaultProps, "menuPortalTarget", {
    configurable: true,
    enumerable: true,
    get() {
      return typeof document !== "undefined" ? document.body : null;
    },
  });
}

applySelectPortalDefaults(Select);
applySelectPortalDefaults(CreatableSelect);
